<template>
  <div class="regfest-service-auth">
    <el-card class="regfest-service-auth__card card">
      <h1>Вход</h1>
      <el-form
        ref="form"
        :model="authModel"
        :rules="rules"
        @submit.native.prevent
      >
        <el-form-item label="Логин" prop="login">
          <el-input v-model="authModel.login"/>
        </el-form-item>
        <el-form-item label="Пароль" prop="password">
          <el-input
            type="password"
            v-model="authModel.password"
          />
        </el-form-item>
        <el-button
          type="primary"
          native-type="submit"
          style="margin-top: 10px; width: 100%;"
          @click="authAttempt"
          :loading="authorizing"
        >
          Войти
        </el-button>
      </el-form>
    </el-card>
    <div >
    </div>
  </div>
</template>

<script>
export default {
  name: 'Auth',
  data() {
    return {
      authModel: {
        login: '',
        password: '',
      },
      authorizing: false,
      rules: {
        login: [
          { required: true, message: 'Укажите логин' },
        ],
        password: [
          { required: true, message: 'Укажите пароль' },
        ],
      },
    };
  },
  methods: {
    authAttempt() {
      this.$refs.form.validate()
        .then(() => {
          this.authorizing = true;
          this.$accessManager.login({
            username: this.authModel.login,
            password: this.authModel.password
          })
          .then(response => this.$router.replace({name: 'ServiceIndex'}))
          .finally(() => this.authorizing = false);
        });
    },
  },
};
</script>

<style lang="scss">
@import "../../../styles/variables";

.regfest-service-auth {
  width: 100%;
  height: 100%;
  background-image: url("../../../../../public/img/fullscreen-bg.jpg");
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  &__card {
    width: 100%;
    max-width: 360px;
    position: absolute;
    top: calc(50% - 152px);
    left: calc(50% - 180px);
    @media (max-width: $mq-small-device) {
      left: 0;
    }
  }
}
</style>
